import {
  BUTTON_CLICKED_EVENT,
  LINK_CLICKED_EVENT,
  BLOG_CLICKED_EVENT,
} from './constants'

export function buttonClickedEvent (buttonName = '', link = '') {
  return (dispatch) => {
    return dispatch({
      type: BUTTON_CLICKED_EVENT,
      payload: { buttonName, link },
    })
  }
}

export function linkClickedEvent (link = '') {
  return (dispatch) => {
    return dispatch({
      type: LINK_CLICKED_EVENT,
      payload: { link },
    })
  }
}

export function blogClickedEvent (link = '') {
  return (dispatch) => {
    return dispatch({
      type: BLOG_CLICKED_EVENT,
      payload: { link },
    })
  }
}
